// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "frontend-assets/css/" + chunkId + "." + {"208":"080e3cb2","675":"55a52531","717":"b19c02bc","773":"f2b98544","794":"b6462807","924":"ac98f56b","966":"241f3400"}[chunkId] + ".css";
};